import React from "react";
import { Button } from "primereact/button";
import { CommonModal } from "@/core/components/commonModal/CommonModal";
import { SvgIcon } from "@/core/components/svgIcon/SvgIcon";
import { OrganizationSearchViewModel } from "../../model/types";

interface OrganizationSearchModalProps {
  isOpen: boolean;
  onClose: () => void;
  orgSearch: OrganizationSearchViewModel;
}

export const OrganizationSearchModal: React.FC<
  OrganizationSearchModalProps
> = ({ isOpen, onClose, orgSearch }) => {
  const {
    searchQuery,
    setSearchQuery,
    searchResults,
    searchLoading,
    selectedOrg,
    setSelectedOrg,
    joinLoading,
    inviteOrganization,
  } = orgSearch;

  return (
    <CommonModal
      isOpen={isOpen}
      onClose={onClose}
      hasForm={false}
      width={600}
      height={550}
      icon=""
      actions={
        <div className="form-actions">
          <div className="form-actions-container">
            <button type="button" className="btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <Button
              type="button"
              onClick={() => {
                if (selectedOrg) {
                  inviteOrganization(selectedOrg.id);
                }
              }}
              disabled={!selectedOrg || joinLoading}
              loading={joinLoading}
            >
              {joinLoading ? "Inviting..." : "Invite Organisation"}
            </Button>
          </div>
        </div>
      }
    >
      <div className="proModal">
        <div className="proModal-title">Search for an organisation</div>
        <div className="proModal-orgSearch">
          <div className="proModal-orgSearch-input">
            <div className="search-input-wrapper">
              <SvgIcon icon="icon-magnifier" className="search-icon" />
              <input
                type="text"
                placeholder="Search for organization"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="search-input"
                autoFocus
              />
            </div>
            {searchLoading && (
              <div className="search-loading">Searching...</div>
            )}
            {searchResults.length > 0 && (
              <div className="search-results">
                {searchResults.map((org) => (
                  <div
                    key={org.id}
                    className={`search-result-item ${
                      selectedOrg?.id === org.id ? "selected" : ""
                    }`}
                    onClick={() => setSelectedOrg(org)}
                  >
                    <div className="org-title">{org.title}</div>
                    <div className="org-details">
                      {org.partner_type?.name} • {org.country?.name}
                    </div>
                  </div>
                ))}
              </div>
            )}
            {searchQuery.length >= 3 &&
              !searchLoading &&
              searchResults.length === 0 && (
                <div className="no-results">No organizations found</div>
              )}
          </div>
        </div>
      </div>
    </CommonModal>
  );
};
